/* eslint-disable */
export default () => {
  // content goes here

  if ($('.coveo-wrapper').length) {

    let open = false;

    const $controller = $('.coveo-filter-controller'),
          $filters = $('.coveo-facet-column');

    if (window.innerWidth < 1000 && open) {
      $('.coveo-dropdown-header-wrapper').css('display', 'none');
    }

    if (window.innerWidth < 1000 && !open) {
      $('.coveo-dropdown-header-wrapper').css('display', 'none');
    }

    $(window).resize(() => {
      if (window.innerWidth >= 1000) {
        $filters.css('display', 'block');
        return;
      }

      if (window.innerWidth < 1000 && open) {
        $filters.css('display', 'block');
        $('.coveo-dropdown-header-wrapper').css('display', 'none');
        return;
      }

      if (window.innerWidth < 1000 && !open) {
        $filters.css('display', 'none');
        $('.coveo-dropdown-header-wrapper').css('display', 'none');
      }
    });

    $controller.click((e) => {
      e.preventDefault();

      if (open) {
        open = false;
        $controller.removeClass('-opened');
        $controller.addClass('-closed');
        $filters.slideToggle();
      } else {
        open = true;
        $controller.removeClass('-closed');
        $controller.addClass('-opened');
        $filters.slideToggle();
      }
    });
  }
};
